import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Tooltip from '@material-ui/core/Tooltip';
import { FormattedMessage } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import { VerticalAlignBottomOutlined } from '@material-ui/icons';
import { isDate, isMoney, isNumber } from '../../../utils/report-utils';
import MoneyFormat from '../MoneyFormat';
import { formatTimestampAsDateWithTime } from '../../../utils/dates-utils';
import { MACHINE_ID_COLUMN, NUMBER_COLUMN, SIE_EXPORT_COLUMN } from '../../pages/reports/standard/StandardReportConsts';
import PropTypes from 'prop-types';

const styles = (() => ({
  numberCellWrapper: {
    width: '100%',
    textAlign: 'right',
  },
  regularCellWrapper: {
    width: '100%',
    textAlign: 'center',
    '& button': {
      '& svg': {
        color: 'green',
      },
    },
  },
}));

const DataGridCell = (props) => {
  const {
    header,
    value,
    LogRecordId,
    classes,
    setDownloadProgress,
    machinesOptions,
    downloadZReport,
    machineId,
    timeFormat,
    downloadZReportDetails,
  } = props;
  
  if (header === SIE_EXPORT_COLUMN) {
    return <span className={classes.regularCellWrapper}>
      <Tooltip placement="right"
               title={<FormattedMessage id="page.zreports.table.tooltip.print.copy" defaultMessage="Print copy" />}>
        <span style={{ marginLeft: 8 }}>
          SIE
          <IconButton
            onClick={() => downloadZReport(setDownloadProgress, value, LogRecordId, machineId, downloadZReportDetails, true)}>
            <VerticalAlignBottomOutlined />
          </IconButton>
        </span>
      </Tooltip>
    </span>;
  }
  
  if (header === NUMBER_COLUMN) {
    return <span className={classes.regularCellWrapper}>{value}
      <Tooltip placement="right"
               title={<FormattedMessage id="page.zreports.table.tooltip.print.copy" defaultMessage="Print copy" />}>
        <span style={{ marginLeft: 8 }}>
          <IconButton
            onClick={() => downloadZReport(setDownloadProgress, value, LogRecordId, machineId, downloadZReportDetails, false)}>
            <VerticalAlignBottomOutlined />
          </IconButton>
        </span>
      </Tooltip>
    </span>;
  }
  if (header === MACHINE_ID_COLUMN) {
    const machineOption = machinesOptions.find(option => option.value === value)?.label;
    if (machineOption) {
      return machineOption;
    }
  }
  if (isNumber(value)) {
    return <span className={classes.numberCellWrapper}>{isMoney(value, header) ?
      <MoneyFormat value={value} />
      : value}</span>;
  }
  if (isDate(header)) {
    return <span className={classes.regularCellWrapper}>{timeFormat(Date.parse(value))}</span>;
  }
  return <span className={classes.regularCellWrapper}>{value}</span>;
  
};

DataGridCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  header: PropTypes.string,
  classes: PropTypes.object,
  label: PropTypes.object,
  timeFormat: PropTypes.func,
  LogRecordId: PropTypes.string,
  machineId: PropTypes.string,
  downloadZReport: PropTypes.func,
  machinesOptions: PropTypes.array,
  setDownloadProgress: PropTypes.func,
};

DataGridCell.defaultProps = {
  timeFormat: formatTimestampAsDateWithTime,
};

export default withStyles(styles)(DataGridCell);